module.exports = __webpack_public_path__ + "static/media/img_phone-light-half.3bed0e4b.png";